export const selectCartCount = (state) => state.cart.cartCount;
export const selectCart = (state) => state.cart.cart;
export const selectCartItems = (state) => {
  const items = state.cart.cart;
  return items.map((item) => item.item);
};
//by business id
export const selectCartProducts = (businessId) => (state) => {
  const items = state.cart.cart;
  return items.find((item) => item.businessId === businessId);
};
export const selectCartCheckoutByBusinessId = (businessId) => (state) => {
  if (businessId) {
    const items = state.cart?.cart ? state.cart?.cart : [];
    if (state.cart) {
        if(items.length > 0){
            const cart = items.find((item) => item.businessId === businessId);
            return cart;
        }else{
            return {};
        }
    } else {
      return {};
    }
    // const products = cart.items.map(item => item)
  } else {
    return {};
  }
};

const EMPTY_OBJECT = {}; // Define a constant empty object

export const selectCartCheckoutByBusinessIdAndFulfillment = (businessId, fulfillOption) => (state) => {
  if (!businessId || !fulfillOption) return EMPTY_OBJECT;

  const items = state.cart?.cart ?? [];

  if (items.length > 0) {
    const cart = items.find((item) => item.businessId === businessId);

    if (cart) {
      // Filter items that have the given fulfillOption enabled
      const filteredItems = cart.items.filter(
        (item) => item.fulfillmentOptions?.[fulfillOption]?.enabled === true
      );

      if (filteredItems.length > 0) {
        return { ...cart, items: filteredItems }; // Return cart with filtered items
      }
    }
  }

  return EMPTY_OBJECT;
};


export const selectServiceCartCheckoutByBusinessId =
  (businessId) => (state) => {
    if (businessId) {
      const service = state.cart.service;
      if (service && service.businessId === businessId) {
        return service;
      } else {
        return {};
      }
    }
  };

export const selectAutoshipCartCheckoutByBusinessId =
  (businessId) => (state) => {
    if (businessId) {
      const autoship = state.cart.autoship;
      if (autoship && autoship.businessId === businessId) {
        return autoship;
      } else {
        return {};
      }
    }
  };
